<template>
    <div>
        <div class="row mb-2">
            <div v-for="(item, idx) in list" :key="idx" class="col-sm-4 mb-1">
                <div class="d-flex border rounded p-2">
                    <div class="form-group form-check mr-2">
                        <input v-if="selectedGroup.includes(item.id)" type="checkbox" class="form-check-input" @change="selectGroup(item.id)" checked>
                        <input v-else type="checkbox" class="form-check-input" @change="selectGroup(item.id)">
                    </div>
                    <span class="text-truncate flex-fill">
                        <a href="#" @click.prevent="openGroupMembers(item.group_type, item.id)" >{{item.group_nm}}</a>
                    </span>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-sm-4">
                <button class="btn btn-danger btn-block" :disabled="disableBtn" @click="sendMailAll">一括送信</button>
            </div>
        </div>
        <div class="form-group form-check mr-1 my-1">
            <input v-model="isTestMail" type="checkbox" class="form-check-input">
            <span class="text-danger-cust">一括送信日更新しない(テスト送信など)</span>
        </div>
    </div>
</template>

<script>
    /** 
        mailType: 1(tech１件), 2(tech一括), 3(案件１件), 4(案件一括) 
    **/
    import {EventBus} from 'js/event-bus'
    import {mapGetters} from 'vuex'

    export default {
        props: {
            list: Array,
            type: String,
            opt: {
                type: Object,
                default: function () {
                    return {}
                }
            }
        },
        mounted () {
            console.log('on group')
            this.busOnSendMailCommon()
            this.busOnSendMailAllCommon()
        },
        data () {
            return {
                selectedGroup: [],
                targetId: "",
                isTestMail: false,//trueの場合、一括送信でrecent_out_day更新しない, 個別送信見ない
            }
        },
        computed: {
            disableBtn () {
                return this.selectedGroup.length == 0 ? true : false
            },
        },
        methods: {
            busOnSendMailCommon () {
                EventBus.$on('busOnSendMailCommon', item => {
                    this.sendMail(item.type, item.id)
                })
            },
            busOnSendMailAllCommon () {
                EventBus.$on('busOnSendMailAllCommon', () => {
                    EventBus.$emit('busOnHideInfoMsg')
                    this.sendMail(this.type)
                })
            },
            openGroupMembers (type, id) {
                this.$router.push({name:'SysMailGroup', params: {
                    type: 'partner',
                    group: id
                }})
            },
            selectGroup (id) {
                let idx = this.selectedGroup.findIndex((item)=>item == id)
                if (idx != -1) {
                    this.selectedGroup.splice(idx, 1)
                } else {
                    this.selectedGroup.push(id)
                }
            },
            sendMail (type, id="") {
                let go = true
                if (this.disableBtn) {
                    go = false
                    EventBus.$emit('busOnOpenInfoMsg', {
                        msg: '送信グループは必須です。',
                        lev: 1,
                    })
                    console.log('send mail fail')
                }
                if (go) {
                    console.log('send mail ok')
                    this.$store.dispatch('sendMailCommon', {
                        mailType: type,
                        targetId: id,
                        groups: this.selectedGroup,
                        isTest: this.isTestMail,
                        option: JSON.stringify(this.opt) 
                    })
                }
            },
            sendMailAll () {
                EventBus.$emit('busOnOpenInfoMsg', {
                    msg: '送信可能要員を一括配信しますか？',
                    lev: 2,
                    emitEvt: 'busOnSendMailAllCommon'
                })
            },
        },
    }
</script>

<style lang="stylus">
</style>
